import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
@Component({
    selector: 'app-coin-fall-popup-animation',
    templateUrl: './coin-fall-popup-animation.component.html',
    styleUrls: ['./coin-fall-popup-animation.component.scss'],
    animations: [
        trigger('fallAnimation', [
            state('falling', style({
                top: '100vh',
                opacity: 1, // Show the block when it starts falling
                transform: 'rotate(20deg)'
            })),
            transition('* => falling', [
                animate('{{duration}}s {{delay}}s', style({
                    top: '100vh',
                    opacity: 1, // Ensure it is visible during the fall
                    transform: 'rotate(20deg)'
                }))
            ], { params: { duration: 2, delay: 0 } }) // Adjust the duration for faster animation
        ])
    ],
    standalone: false
})
export class CoinFallPopupAnimationComponent  implements OnInit {
  blocks: any[] = [];

  constructor() {}

  ngOnInit() {
    // Create an array of blocks with random sizes and positions
    for (let i = 0; i < 10; i++) {  // Adjust the number of blocks as needed
      const size = Math.random() * 50 + 20; // Random size between 20px and 70px
      const left = Math.random() * 100; // Random left position between 0% and 100%
      const delay = Math.random() * 3; // Random delay between 0s and 3s
      this.blocks.push({
        size: size,
        left: left,
        state: {
          value: 'falling',
          params: {
            duration: 2, // duration in seconds, make it faster
            delay: delay // delay in seconds
          }
        }
      });
    }
  }

  animationDone(block: any) {
    const index = this.blocks.indexOf(block);
    if (index >= 0) {
      this.blocks.splice(index, 1);
    }
  }
}